import { Typography, Breadcrumbs, Link } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeIcon from "@mui/icons-material/Home"; // Add Home Icon
import "../../../component/styles/breadcrumb.css";
import { useNavigate } from 'react-router-dom';

const Breadcrumb = ({ items }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs
      separator={<ChevronRightIcon className="arrow-icon" />}
      sx={{ alignItems: "center" }}
      aria-label="breadcrumb"
    >
      {items &&
        items.map((item, idx) => {
          const isFirst = idx === 0;
          const isLast = idx === items.length - 1;
          return (
            <span key={item.title} className="flex items-center gap-1">
              {isFirst && (
                <HomeIcon
                  style={{
                    fontSize: "18px",
                    verticalAlign: "middle",
                    marginRight: "2px"
                  }}
                  className="breadcrumb-home"
                />
              )}
              {item.to && !isLast ? (
                <Link
                  onClick={() => navigate(item.to)}
                  underline="hover"
                  className="link-navigator"
                  style={{ display: "inline-flex", alignItems: "center" }}
                >
                  <span className="text-[13px]">{item.title}</span>
                </Link>
              ) : (
                <span
                  className={`font-[600] text-[13px] ${
                    isLast
                      ? "text-[#2DA5F3]" 
                      : "text-[var(--primary-text-color)]"
                  }`}
                >
                  {item.title}
                </span>
              )}
            </span>
          );
        })}
    </Breadcrumbs>
  );
}

export default Breadcrumb;
